





























import { defineComponent } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";
import InputRange from "@/components/BaseInputs/InputRange";
import DraggableWrapper from "@/components/DraggableWrapper";
import VolumeInput from "./components/VolumeInput.vue";
import useAudioPlayer from "./hooks/useAudioPlayer";
import useGlobalAudioController from "./hooks/useGlobalAudioController";

export default defineComponent({
  name: "GlobalAudioPlayer",
  components: { DraggableWrapper, VolumeInput, InputRange, BaseIconButton },
  setup() {
    const { activeFile, fileList, hasPrev, hasNext, prev, next, reset } = useGlobalAudioController();

    const {
      isPlay,
      duration,
      currentTime,
      formattedRemainingTime,
      volume,
      muted,
      toggleAudio,
      setTime,
    } = useAudioPlayer(activeFile, next);

    return {
      isPlay,
      duration,
      currentTime,
      formattedRemainingTime,
      fileList,
      hasPrev,
      hasNext,
      volume,
      muted,
      toggleAudio,
      setTime,
      prev,
      next,
      reset,
    };
  },
});
